const TotalSelectedTitle = ({ title, total }) => {
  return (
    <div className='flex items-center gap-8'>
      <div className='text-base'>{title}</div>

      <div className='text-sm font-light text-muted-foreground'>
        {`${total} selected`}
      </div>
    </div>
  );
};

export default TotalSelectedTitle;
